var isiPad = navigator.userAgent.match(/iPad/i) != null;
function CheckOnScreen() {
	$('.svg-animation:not(.svg-loaded)').each(function () {
		if ($(this).isOnScreen()) {
			$(this).addClass('svg-loaded');
			if (!isiPad){
				var myVivus = new Vivus($(this).find('svg')[0], {
					type: 'sync',
					pathTimingFunction: Vivus.EASE,
					animTimingFunction: Vivus.EASE_OUT,
					duration: 300
				});
				myVivus.play();
			}
		}
	});
}

$(window).on('load', function () {
	CheckOnScreen();

	$(window).scroll(function () {
		CheckOnScreen();
	});
});


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/animation/svg-animation.js
 **/